import React from 'react'
import ContactUs from '../ContactUs/ContactUs'

const ContactPage = () => {
    return (
        <>
            <div>
                <ContactUs />
            </div>
        </>
    )
}

export default ContactPage
